
import React from 'react';

const HeartHandCareUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M22.5 26h-5c-.55 0-1-.45-1-1v-6.24c0-.77.3-1.5.85-2.04l3.78-3.79c.59-.6 1.49-.84 2.29-.64l.32-3.81a2.4 2.4 0 012.38-2.19 2.39 2.39 0 012.39 2.39v8.25c0 .52-.2 1.01-.57 1.38l-4.16 4.47c-.18.17-.28.41-.28.67V25c0 .55-.45 1-1 1zm-4-2h3v-.55c0-.76.29-1.49.81-2.05l4.19-4.5V8.67c0-.22-.17-.39-.39-.39a.4.4 0 00-.39.36l-.46 5.48-.08-.01c.17.78-.05 1.63-.65 2.23l-3 3.01-1.42-1.41 3-3.01c.16-.16.16-.43 0-.59-.21-.21-.37-.21-.58 0l-3.78 3.79c-.15.16-.25.39-.25.63V24zM14.5 26h-5c-.55 0-1-.45-1-1v-1.55c0-.25-.1-.5-.27-.68l-4.19-4.5c-.34-.35-.54-.84-.54-1.36V8.67a2.39 2.39 0 012.39-2.39 2.4 2.4 0 012.38 2.19l.32 3.81c.8-.2 1.69.04 2.29.64l3.78 3.79c.54.55.84 1.28.84 2.05V25c0 .55-.45 1-1 1zm-4-2h3v-5.24c0-.24-.1-.46-.26-.63l-3.78-3.79c-.21-.21-.37-.21-.58 0-.16.16-.16.43 0 .59l3 3.01-1.42 1.41-3-3.01c-.6-.6-.82-1.45-.65-2.23l-.08.01-.45-5.49a.4.4 0 00-.39-.36c-.22 0-.39.18-.39.4v8.25l4.19 4.48c.52.56.81 1.28.81 2.05V24zM16 15c-.25 0-.5-.09-.7-.28l-4.52-4.4c-.83-.81-1.28-1.9-1.28-3.07C9.5 4.91 11.34 3 13.61 3c.87 0 1.7.28 2.39.79.69-.51 1.52-.79 2.39-.79 2.27 0 4.11 1.91 4.11 4.25 0 1.17-.45 2.26-1.27 3.07l-4.54 4.4c-.19.19-.44.28-.69.28zM13.61 5c-1.16 0-2.11 1.01-2.11 2.25 0 .63.24 1.21.68 1.65L16 12.61l3.83-3.72c.43-.43.67-1.01.67-1.64 0-1.24-.95-2.25-2.11-2.25-.62 0-1.21.29-1.61.8-.38.48-1.19.48-1.57 0-.4-.51-.98-.8-1.6-.8zM23.5 30h-15v2h15v-2z'
			></path>
		</svg>
	);
};

export default HeartHandCareUnderline;
